import React from 'react'
import { Subscription, Buttons } from './components'
import styles from './App.module.css'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'

const App = () => {
  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <CardMedia
          className={styles.cardMedia}
          image={require('./images/illustration-hero.svg').default}
          title='Hero Image'
        />
        <CardContent className={styles.cardContent}>
          <Typography
            variant='h5'
            align='center'
            component='h5'
            className={styles.cardTitle}
          >
            Order Summary
          </Typography>
          <Typography
            variant='body2'
            color='textSecondary'
            align='center'
            component='p'
            className={styles.bodyText}
          >
            You can now listen to millions of songs, audiobooks, and podcasts on
            any device anywhere you like!
          </Typography>
          <Subscription />
        </CardContent>
        <CardActions className={styles.cardActions}>
          <Buttons />
        </CardActions>
      </Card>
    </div>
  )
}

export default App
